// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ey-U","title":"Info_title__39xnh","selects":"Info_selects__1MQA_","requiredAsterisk":"Info_requiredAsterisk__3WMko"};